// extracted by css-extract-rspack-plugin
export default {"nav":"nav--i07CRuE5DNA3mMxu","navSizeMedium":"nav-size-medium--DuPlPBVYAm4eDxMH","item":"item--xUgCCy4pZ1ssRhAT","itemSelected":"item_selected--wAf_0Wtrp8I7Vc9R"};